import React, { useState, useEffect, Component } from 'react';
import { Button } from 'react-bootstrap';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut, sendPasswordResetEmail } from '@firebase/auth';
import { auth } from "../services/firebaseConfig";
import Register from '../components/RegisterModal';

function UserLogin({ getGetUser }) {
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [user, setUser] = useState({});
    const handleClose = () => setShow(false);
    const [show, setShow] = useState(false);
    //const [loginEmail, setLoginEmail] = useState('');
    //const [loginPassword, setLoginPassword] = useState(''); 

    useEffect(() => {
        onAuthStateChanged(auth, (currentUser) => {
            if (!currentUser) {
                setUser({});
                getGetUser({});
            }
            else {
                setUser(currentUser);
                getGetUser(currentUser);
            }
        });
    }, []);

    const register = async () => {
        setShow(true);
    }

    const login = async () => {
        try {
            await signInWithEmailAndPassword(
                auth,
                userEmail,
                userPassword
            ).then((userCredential) => {
                setUser(userCredential.user);
            });
        } catch (error) {
            if (error.code.toString().indexOf("invalid-email") !== -1) {
                alert('Email address is currently not registered.');
            }
            if (error.code.toString().indexOf("wrong-password") !== -1) {
                alert('Password does not match our records.');
            }
            if (error.code.toString().indexOf("too-many-requests") !== -1) {
                alert('This account has been has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.');
            }
            if (error.code.toString().indexOf("user-not-found") !== -1) {
                alert('Email address is currently not registered.');
            }
            console.log(error.code + ":" + error.message);
        }
    }
    const logout = async () => {
        await signOut(auth);
        setUser({});
        getGetUser({});
        setUserEmail("");
        setUserPassword("");
        //window.location.reload();
    }

    const resetPass = async () => {
        try {
            await sendPasswordResetEmail(auth, userEmail).then(() => {
                alert('Check your inbox for an email from noreply@pickem - 3a187.firebaseapp.com to reset your password.')
            });
        } catch (error) {
            if (error.code.toString().indexOf("missing-email") !== -1) {
                alert('Enter your email address first, then select reset password');
            }
            if (error.code.toString().indexOf("invalid-email") !== -1) {
                alert('Email is not vaild.');
            }
            if (error.code.toString().indexOf("user-not-found") !== -1) {
                alert('Email address is currently not registered.');
            }
            console.log(error.code);
        }
    }

    return (
        <>
        <div className="whiteText centerAlign">
            <div className={user.uid ? "hidden" : "logIn"}>
                <p className="loginHeader">Login/Register</p>
                <input className="loginInput"
                    name="RegisterEmail"
                    placeholder="Email..."
                    value={userEmail}
                    onChange={(event) => {setUserEmail(event.target.value);}}
                />
                <input className="loginInput"
                    name="RegisterPassword"
                    placeholder="Password..."
                    value={userPassword}
                    onChange={(event) => { setUserPassword(event.target.value); }}
                />
                    <Button className="loginButtonv2" variant="primary" size="sm" onClick={login}>Login</Button><Button variant="link" className="registerLink" onClick={register}>Register</Button>
                    <Button className="resetPassLink" variant="link" onClick={resetPass}>reset password</Button>
            </div>
            <div className={user.uid ? "logOut" : "hidden"}>
            <p className="loginHeader"> Logged in as: </p>
            {user?.email}
                    <Button className="logoutButton" variant="outline-danger" size="sm" onClick={logout}> Sign Out </Button>
            </div>
        </div>
        <Register show={show} handleClose={handleClose} user={user} />
        </>

        )
}

export default UserLogin;